import { Doctype } from '../types/indices';

/**
 * Generates a search URL with the given parameters
 */
export function getSearchUrl({
   searchStr,
   doctype,
}: {
   searchStr: string;
   doctype?: Doctype;
}): string {
   const url = new URL('/Search', window.location.origin);

   if (searchStr) {
      url.searchParams.set('query', searchStr);
   }

   if (doctype) {
      url.searchParams.set('doctype', doctype);
   }

   return url.toString();
}
